/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{Z as o}from"../../../../chunks/vec4f64.js";const s=1.2,c=o,r=4;export{r as labelMarginPx,s as suspendResumeExtentOptimism,c as transparentUnit};
